import { AutonumericModule } from '@angularfy/autonumeric';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { PocaeComponent } from './pocae/pocae.component';
import { ResumenComponent } from './pocae/resumen/resumen.component';
import { HeaderComponent } from './pocae/header/header.component';
import { TarjetasComponent, DialogDesafiliacion } from './pocae/tarjetas/tarjetas.component';
import { MovimientosComponent } from './pocae/tarjetas/movimientos/movimientos.component';
import { SolicitudesComponent } from './pocae/tarjetas/solicitudes/solicitudes.component';
import { PerfilComponent } from './pocae/perfil/perfil.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SettingsHttpService } from './service/setting.http.service'
import { BlockCopyPasteDirective } from './blockCopyAndPaste.directive';
import { UbicacionesComponent } from './pocae/ubicaciones/ubicaciones.component';
import { CentrosAtencionComponent } from './pocae/ubicaciones/centros-atencion/centros-atencion.component';
import { PuntosVentaComponent } from './pocae/ubicaciones/puntos-venta/puntos-venta.component';
import { FilterPipe } from './pipes/filter.pipe';
import { FilterPVentaPipe } from './pipes/filter-pventa.pipe';
import { MapsComponent } from './pocae/ubicaciones/maps/maps.component';
import { DireccionesComponent } from './pocae/ubicaciones/direcciones/direcciones.component';
import { HorariosComponent } from './pocae/ubicaciones/horarios/horarios.component';
import { FilterDireccionesPipe } from './pipes/filter-direcciones.pipe';
import { FilterHorariosPipe } from './pipes/filter-horarios.pipe';
import { MonedaPipe } from './pipes/moneda.pipe';
import { ZonasPagasComponent } from './pocae/ubicaciones/zonas-pagas/zonas-pagas.component';

import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { AsideComponent } from './pocae/aside/aside.component';
import { InterceptorInterceptor } from './service/interceptor.interceptor';
import { SolicitudComponent } from './pocae/solicitud/solicitud.component';
import { SessionExpiredComponent } from './pocae/sesion-expired-modal.component';
import { HttpInterceptor } from './service/http.interceptor';



export function app_Init(settingsHttpService: SettingsHttpService) {
  return () => settingsHttpService.initializeApp();
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PocaeComponent,
    ResumenComponent,
    HeaderComponent,
    TarjetasComponent,
    MovimientosComponent,
    SolicitudesComponent,
    PerfilComponent,
    BlockCopyPasteDirective,
    UbicacionesComponent,
    CentrosAtencionComponent,
    PuntosVentaComponent,
    FilterPipe,
    FilterPVentaPipe,
    MapsComponent,
    DireccionesComponent,
    HorariosComponent,
    FilterDireccionesPipe,
    FilterHorariosPipe,
    MonedaPipe,
    ZonasPagasComponent,
    DialogDesafiliacion,
    AsideComponent,
    SolicitudComponent,
    SessionExpiredComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    AutonumericModule.forRoot(),
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: app_Init,
      deps: [SettingsHttpService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
